import { BrandColors, Colors } from "@/constants/theme";
import React from "react";
import { StyleSheet, Switch, useColorScheme, View } from "react-native";
import { ThemedText } from "./themed-text";

interface EquipmentItemProps {
  label: string;
  value: boolean;
  onValueChange: (val: boolean) => void;
  isLast?: boolean;
  readOnly?: boolean;
}

export const EquipmentItem: React.FC<EquipmentItemProps> = ({
  label,
  value,
  onValueChange,
  isLast,
  readOnly = false,
}) => {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];
  return (
    <View style={[styles.equipmentItem, { borderBottomColor: theme.border }, isLast && styles.equipmentItemLast]}>
      <ThemedText style={styles.equipmentLabel}>{label}</ThemedText>
      <Switch
        value={value}
        onValueChange={onValueChange}
        trackColor={{ false: theme.border, true: BrandColors.primary + "90" }}
        ios_backgroundColor={theme.border}
        disabled={readOnly}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  equipmentItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
  },
  equipmentItemLast: {
    borderBottomWidth: 0,
  },
  equipmentLabel: {
    fontSize: 16,
  },
});
